import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import AOS from "aos";

import { axiosInstnace as Axios, getUserData } from "../../util/util";
import { endPoints } from "../../config";
import { getCityState } from "../../action/user_action";
import NoPackage from "./NoPackage";

const PackageContainer = (props) => {
  //Set the initial state
  const [typeClass, handleTypeClass] = useState("package_listing_wrapper");
  const [stateClass, handleStateClass] = useState("package_listing_wrapper");
  const [cityClass, handleCityClass] = useState("package_listing_wrapper");
  const [packageType, handlePackageType] = useState("Package Type");
  const [state, handleState] = useState("State");
  const [city, handleCity] = useState("City");
  const [package_arrow, HandlePackage_arrow] = useState("package_dropdown");
  const [state_arrow, HandleState_arrow] = useState("package_dropdown");
  const [city_arrow, HandleCity_arrow] = useState("package_dropdown");
  const [frequency, handleFrequency] = useState([]);
  const [cityList, handleCityList] = useState([]);
  const [fctPerday3, handleFctPerday3] = useState("");
  const [totalFct3, handletotalFct3] = useState("");
  const [totalCost3, handletotalCost3] = useState("");
  const [discount3, handlediscount3] = useState("");
  const [discountedCost3, handlediscountedCost3] = useState("");
  const [total3, handletotal3] = useState("");
  const [fctPerday5, handlefctPerday5] = useState("");
  const [totalFct5, handletotalFct5] = useState("");
  const [totalCost5, handletotalCost5] = useState("");
  const [discount5, handlediscount5] = useState("");
  const [discountedCost5, handlediscountedCost5] = useState("");
  const [total5, handletotal5] = useState("");
  const [fctPerday7, handlefctPerday7] = useState("");
  const [totalFct7, handletotalFct7] = useState("");
  const [totalCost7, handletotalCost7] = useState("");
  const [discount7, handlediscount7] = useState("");
  const [discountedCost7, handlediscountedCost7] = useState("");
  const [total7, handletotal7] = useState("");
  const [Rodp, handleRodp] = useState("");
  const [customRodp, handleCustomRodp] = useState("");
  const [startTime, handleStartTime] = useState("");
  const [endTime, handleendTime] = useState("");
  const [showPackage, handleShowPackage] = useState(undefined);
  const [mapcityCount, handleMapCityCount] = useState(1);
  const [campaigns, handleCampaigns] = useState([]);
  const [stationview, handlestationView] = useState("single");
  const [stations, handleStations] = useState(props.stations);
  const [stationwisedetails, handlestationwisedetails] = useState(
    props.stationwisedetails
  );
  const [multistatedetails, handlemultistatedetails] = useState(
    props.multistatedetails
  );
  const [inDivStations, handleindivStations] = useState();

  useEffect(() => {
    ////console.log('props - ', props);
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    console.log("User info");
    console.log(userInfo);
    userInfo ? getPreviousCampaigns(userInfo.email) : "";
    const { latitude, longitude } = props;
    if (latitude && longitude) {
      getNearestLocation(latitude, longitude);
    } else {
      props.getCityState();
    }
  }, [props.longitude]);

  useEffect(() => {
    handleStations(props.stations);
  }, [props.stations]);

  useEffect(() => {
    handlestationwisedetails(props.stationwisedetails);
    handleindivStations(Object.keys(props.stationwisedetails));
  }, [props.stationwisedetails]);

  useEffect(() => {
    handlemultistatedetails(props.multistatedetails);
  }, [props.multistatedetails]);

  const getPreviousCampaigns = async (email) => {
    try {
      const campaigns = await Axios.get(endPoints.getPreviousAudio, {
        params: { email },
      });
      console.log("campaigns");
      console.log(campaigns.data.data.data);
      handleCampaigns(campaigns.data.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const addStation = () => {
    let stationslist = stations;
    stationslist.push(city);
    stationslist = [...new Set(Array.from(stationslist))];
    handleStations(stationslist);
    props.handleStations(stationslist);
  };

  const getFrequencyPackage = async (frequency) => {
    try {
      const data = await Axios.get(endPoints.getFrequencyPackage, {
        params: { frequency },
      });
      const frequencyArray = data.data.data.data;
      if (frequencyArray) {
        handleFrequency(frequencyArray);
        getPackageDetails("frequency", frequencyArray);
      } else {
        handleFrequency([]);
      }
    } catch (error) {
      handleFrequency([]);
    }
  };

  //Fetching the initial state
  const getPackageDetails = (field, value, show_package) => {
    let freq = [];
    let rodp = 0;
    if (field === "frequency" && value) {
      freq = value;
    } else {
      freq = frequency;
    }

    ////console.log("Rodp", Rodp);
    ////console.log("value", value);

    if (field === "rodp" && value) {
      //rodp = Math.round(value/10);
      rodp = value / 10;
    } else {
      rodp = Rodp / 10;
      // rodp = Math.round(Rodp/10)
    }

    if (
      freq.length > 0 &&
      props.stateList &&
      props.stateList.toJS().length > 0 &&
      rodp > 0
    ) {
      let discount3 = Math.round(
        (freq[0].discount * (freq[0].fctPerDay * rodp * 3)) / 100
      );
      let discount5 = Math.round(
        (freq[1].discount * (freq[1].fctPerDay * rodp * 5)) / 100
      );
      let discount7 = Math.round(
        (freq[2].discount * (freq[2].fctPerDay * rodp * 7)) / 100
      );
      let total3 = Math.round(freq[0].fctPerDay * rodp * 3 - discount3);
      let total5 = Math.round(freq[1].fctPerDay * rodp * 5 - discount5);
      let total7 = Math.round(freq[2].fctPerDay * rodp * 7 - discount7);
      handleFctPerday3(freq[0].fctPerDay);
      handletotalFct3(freq[0].totalFct);
      handletotalCost3(freq[0].fctPerDay * rodp * 3);
      handlediscount3(freq[0].discount);
      handlediscountedCost3(discount3);
      handletotal3(total3);
      handlefctPerday5(freq[1].fctPerDay);
      handletotalFct5(freq[1].totalFct);
      handletotalCost5(freq[1].fctPerDay * rodp * 5);
      handlediscount5(freq[1].discount);
      handlediscountedCost5(discount5);
      handletotal5(total5);
      handlefctPerday7(freq[2].fctPerDay);
      handletotalFct7(freq[2].totalFct);
      handletotalCost7(freq[2].fctPerDay * rodp * 7);
      handlediscount7(freq[2].discount);
      handlediscountedCost7(discount7);
      handletotal7(total7);
      handlePackageType(freq[0].name);
      handleRodp(rodp * 10);
      handleCustomRodp(customRodp);
      handleendTime(endTime);
      handleStartTime(startTime);
      // props.getRodp(rodp *10, show_package==="true" ? true : show_package==="false"? false : showPackage);
      props.getRodp(rodp * 10, customRodp, startTime, endTime, true);
    }
  };

  const closeActiveDropDown = () => {
    const activeClass = "package_listing_wrapper display_dropdown";
    if (typeClass === activeClass) {
      handleTypeClass("package_listing_wrapper");
      HandlePackage_arrow("package_dropdown");
    } else if (stateClass === activeClass) {
      handleStateClass("package_listing_wrapper");
      HandleState_arrow("package_dropdown");
    } else if (cityClass === activeClass) {
      handleCityClass("package_listing_wrapper");
      HandleCity_arrow("package_dropdown");
    }
  };

  const getCityListNearBy = async (
    state,
    rodp,
    customRodp,
    startTime,
    endTime,
    nearestCity
  ) => {
    console.log("Rodp in get city list -", rodp);
    ////console.log('Props before - ', props);
    try {
      const data = await Axios.get(endPoints.getCityList, {
        params: { state },
      });
      const cityList = data.data.data.data;

      if (cityList) {
        handleCity(
          props.city && mapcityCount === 1
            ? props.city
            : nearestCity && nearestCity !== "City"
            ? nearestCity
            : cityList[0].station
        );
        console.log(city, "selected city");
        getPackageDetails("rodp", rodp);
        handleMapCityCount(mapcityCount + 1);
        handleRodp(rodp);
        handleCustomRodp(customRodp);
        handleStartTime(startTime);
        handleendTime(endTime);
        props.getRodp(rodp, customRodp, startTime, endTime, true);
        handleCityList(cityList);
        handleShowPackage(true);

        let stationName = {
          station:
            props.city && mapcityCount === 1
              ? props.city
              : nearestCity && nearestCity !== "City"
              ? nearestCity
              : cityList[0].station,
        };
        //console.log(stationName)
        props.handleStationName(stationName ? stationName : cityList[0]);
        //console.log('Props after',props);
      }
      // if(cityList[0].region !="Metros"){
      //     handleShowPackage(false);
      //     props.getRodp(cityList[0].rodpRate, false);
      // }
      else {
        handleCityList([]);
      }
    } catch (error) {
      handleCityList([]);
    }
  };

  //Fetching cities
  const getCityList = async (state) => {
    ////console.log('Props before - ', props);
    try {
      const data = await Axios.get(endPoints.getCityList, {
        params: { state },
      });
      const cityList = data.data.data.data;

      if (cityList) {
        handleCity(
          props.city && mapcityCount === 1 ? props.city : cityList[0].station
        );
        getPackageDetails("rodp", cityList[0].rodpRate);
        handleMapCityCount(mapcityCount + 1);
        handleRodp(cityList[0].rodpRate);
        handleCustomRodp(cityList[0].customRodpRate);
        handleStartTime(cityList[0].startTime);
        handleendTime(cityList[0].endTime);
        props.getRodp(
          cityList[0].rodpRate,
          cityList[0].customRodpRate,
          cityList[0].startTime,
          cityList[0].endTime,
          true
        );
        handleCityList(cityList);
        handleShowPackage(true);
        //console.log(props.city);
        //console.log(mapcityCount);
        //console.log(cityList);
        let stationName = { station: props.city };
        //console.log(stationName);
        props.handleStationName(
          props.city && mapcityCount === 1 && stationName
            ? stationName
            : cityList[0]
        );
        //console.log('Props after',props);
      }
      // if(cityList[0].region !="Metros"){
      //     handleShowPackage(false);
      //     props.getRodp(cityList[0].rodpRate, false);
      // }
      else {
        handleCityList([]);
      }
    } catch (error) {
      handleCityList([]);
    }
  };

  //Fetching Nearist location
  const getNearestLocation = async (latitude, longitude) => {
    try {
      const data = await Axios.get(endPoints.getNearestLocation, {
        params: { latitude, longitude },
      });
      const nearestLocation = data.data.data;
      ////console.log('Nearest location - ', nearestLocation);

      // if(nearestLocation.data.region === "Metros"){
      //     handleShowPackage(true);
      // }
      // if(nearestLocation.data.region != "Metros"){
      //     handleShowPackage(false);
      // }

      if (nearestLocation) {
        let freq = nearestLocation.frequency;
        let rodp = nearestLocation.data.rodpRate / 10;
        handleRodp(rodp * 10);
        props.getRodp(
          rodp * 10,
          nearestLocation.data.customRodpRate,
          nearestLocation.data.endTime,
          nearestLocation.data.endTime,
          true
        );
        handleCustomRodp(nearestLocation.data.customRodpRate);
        handleStartTime(nearestLocation.data.startTime);
        handleendTime(nearestLocation.data.endTime);

        let discount3 = Math.round(
          (freq[0].discount * (freq[0].fctPerDay * rodp * 3)) / 100
        );
        let discount5 = Math.round(
          (freq[1].discount * (freq[1].fctPerDay * rodp * 5)) / 100
        );
        let discount7 = Math.round(
          (freq[2].discount * (freq[2].fctPerDay * rodp * 7)) / 100
        );
        let total3 = Math.round(freq[0].fctPerDay * rodp * 3 - discount3);
        let total5 = Math.round(freq[1].fctPerDay * rodp * 5 - discount5);
        let total7 = Math.round(freq[2].fctPerDay * rodp * 7 - discount7);
        handleFrequency(freq);
        handleFctPerday3(freq[0].fctPerDay);
        handletotalFct3(freq[0].totalFct);
        handletotalCost3(freq[0].fctPerDay * rodp * 3);
        handlediscount3(freq[0].discount);
        handlediscountedCost3(Math.round(discount3));
        handletotal3(total3);
        handlefctPerday5(freq[1].fctPerDay);
        handletotalFct5(freq[1].totalFct);
        handletotalCost5(freq[1].fctPerDay * rodp * 5);
        handlediscount5(freq[1].discount);
        handlediscountedCost5(Math.round(discount5));
        handletotal5(total5);
        handlefctPerday7(freq[2].fctPerDay);
        handletotalFct7(freq[2].totalFct);
        handletotalCost7(freq[2].fctPerDay * rodp * 7);
        handlediscount7(freq[2].discount);
        handlediscountedCost7(Math.round(discount7));
        handletotal7(total7);
        // handleCity(props.city? props.city :nearestLocation.data.station);
        handleCity(
          nearestLocation.data.station
            ? nearestLocation.data.station
            : props.city
        );
        handlePackageType("Effective");
        handleState(nearestLocation.data.state);
        getCityListNearBy(
          nearestLocation.data.state,
          rodp * 10,
          nearestLocation.data.customRodpRate,
          nearestLocation.data.startTime,
          nearestLocation.data.endTime,
          nearestLocation.data.station
        );
      }
    } catch (error) {
      handleCityList([]);
    }
  };
  const removeStations = async (station) => {
    let stationslist = stations.filter((e) => {
      return e !== station;
    });
    let stationdetails = stationwisedetails;
    delete stationdetails[station];
    handleStations(stationslist);
    handlestationwisedetails(stationdetails);
    handleindivStations(Object.keys(stationdetails));
    props.handleStations(stationslist);
  };
  //Choose a package
  const choosePackage = async (
    fctPerDay,
    secondages,
    totalCost,
    discount,
    discountedCost,
    days,
    event
  ) => {
    ////console.log("props", props);
    const data = {
      fctPerDay,
      secondages,
      discount,
      discountedCost,
      totalCost,
      days,
      station: props.station,
      type: "Frequency Based",
      rodp: Rodp,
      campaigns: campaigns,
    };
    props.choosePackage(data);
  };

  AOS.init({});
  let {
    totalSecondages,
    rotationPerDay,
    audioDuration,
    discountPercent,
    totalDays,
  } = multistatedetails;

  //Return the frequence bassed package
  return (
    <div className="package_bg_container" onClick={closeActiveDropDown}>
      <div className="package_detail detail_pack">
        <h2>Packages Detail</h2>
        <h5>Showing Customised Packages For</h5>
        <div style={{ marginTop: "3%" }}>
          <div style={{ display: "inline-block" }}>
            <input
              className="audio_input"
              type="radio"
              id="singlestation"
              name="booking-group"
              checked={stationview === "single"}
            />
            <label
              className="audio_label"
              style={{ color: "white" }}
              htmlFor="singlestation"
              onClick={() => {
                handlestationView("single");
                props.handlestationView("single");
                props.handleStations([]);
                handleStations([]);
                handleindivStations([]);
              }}
            >
              Single Station
            </label>
          </div>
          <div style={{ display: "inline-block", marginLeft: "3%" }}>
            <input
              className="audio_input"
              type="radio"
              id="multi"
              name="booking-group"
              checked={stationview === "multi"}
            />
            <label
              className="audio_label"
              htmlFor="multi"
              style={{ color: "white" }}
              onClick={() => {
                handlestationView("multi");
                props.handlestationView("multi");
                // pickCity(city);
              }}
            >
              Multi Station
            </label>
          </div>
        </div>
      </div>
      <div className="package_detail_selector">
        <div className="package_selector_inner">
          <div className="package_type">
            {stationview && stationview !== "multi" && (
              <React.Fragment>
                <div className="selector_head">Package Type</div>
                <div className="package_dropdown_wrapper">
                  <div
                    className={package_arrow}
                    onClick={() => {
                      handleTypeClass(
                        "package_listing_wrapper display_dropdown"
                      );
                      HandlePackage_arrow("package_dropdown dropdown_open");
                    }}
                  >
                    <span className="package_drop_img">
                      <img src="../../../assets/images/package_icon.png" />
                    </span>
                    <span className="package_default_txt">{packageType}</span>
                  </div>
                  <ul className={typeClass}>
                    {["Dhamaka", "Effective", "Saver"].map((p, i) => (
                      <li
                        key={i}
                        className="package_listing"
                        onClick={() => {
                          handlePackageType(p);
                          getFrequencyPackage(p);
                        }}
                      >
                        <span className="package_listing_img">
                          <img src="../../../assets/images/package_icon.png" />
                        </span>
                        <span className="package_listing_name">{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>

        <div className="package_selector_inner">
          <div className="package_type">
            <div className="selector_head">State</div>
            <div className="package_dropdown_wrapper">
              <div
                className={state_arrow}
                onClick={() => {
                  handleStateClass("package_listing_wrapper display_dropdown");
                  HandleState_arrow("package_dropdown dropdown_open");
                }}
              >
                <span className="package_drop_img">
                  <img src="../../../assets/images/pin_icon.png" />
                </span>
                <span className="package_default_txt">{state}</span>
              </div>
              <ul className={stateClass}>
                {props &&
                  props.stateList &&
                  props.stateList
                    .toJS()
                    .sort()
                    .map((s, i) => (
                      <li
                        key={i}
                        className="package_listing"
                        onClick={() => {
                          handleState(s);
                          getCityList(s);
                          getPackageDetails();
                        }}
                      >
                        <span className="package_listing_img">
                          <img src="../../../assets/images//pin_icon.png" />
                        </span>
                        <span className="package_listing_name">{s}</span>
                      </li>
                    ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="package_selector_inner">
          <div className="package_type">
            <div className="selector_head">City</div>
            <div className="package_dropdown_wrapper">
              <div
                className={city_arrow}
                onClick={() => {
                  handleCityClass("package_listing_wrapper display_dropdown");
                  HandleCity_arrow("package_dropdown dropdown_open");
                }}
              >
                <span className="package_drop_img">
                  <img src="../../../assets/images/pin_icon.png" />
                </span>
                <span className="package_default_txt">{city}</span>
              </div>
              <ul className={cityClass}>
                {cityList.map((c, i) => (
                  <li
                    key={i}
                    className="package_listing"
                    onClick={() => {
                      // if(c.region!="Metros"){
                      //     handleShowPackage(false);
                      //     props.getRodp(c.rodpRate,false);
                      //     getPackageDetails("rodp", c.rodpRate,"false");
                      // }
                      // else{
                      ////console.log("c.rodpRate yhade",c.rodpRate)
                      handleShowPackage(true);
                      props.getRodp(
                        c.rodpRate,
                        c.customRodpRate,
                        c.startTime,
                        c.endTime,
                        true
                      );
                      getPackageDetails("rodp", c.rodpRate, "true");
                      props.handleStationName(c);
                      // }
                      handleCity(c.station);
                      handleRodp(c.rodpRate);
                      handleCustomRodp(c.customRodpRate);
                      handleStartTime(c.startTime);
                      handleendTime(c.endTime);
                    }}
                  >
                    <span className="package_listing_img">
                      <img src="../../../assets/images//pin_icon.png" />
                    </span>
                    <span className="package_listing_name">{c.station}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        {stationview === "multi" && (
          <React.Fragment>
            <div className="package_selector_inner">
              <div className="package_type">
                <div className="choose_plan">
                  <button onClick={addStation}>Add Station</button>{" "}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      {stations.length > 0 && stationview === 'multi' && (
        <div class="choose_plan"
          style={{ marginTop: "2%", color: "white" }}
          onClick={(e) => {
            document
              .getElementById("multiStateCard")
              .scrollIntoView({ behavior: "smooth" });
          }}
        >
          <h2>
            <a>To Customize package and choose plan for the stations selected, click the <b>Next</b> button</a>
          </h2>
          <button>Next</button>
        </div>
      )}
      {stationview === "multi" && (
        <div className="package_card_wrapper" style={{ marginTop: "0" }}>
          <div className="rangebar_wrapper brand_rangeslider view_indiv_card">
            {inDivStations.length > 0 && (
              <div className="package_card_wrapper brand_card">
                {inDivStations.map((inDivStation) => {
                  return (
                    <div className="package_card_inner">
                      <div className="package_card_head">
                        {inDivStation}
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          style={{
                            float: "right",
                            backgroundColor: "#2390CC",
                            border: "1px",
                            fontSize: "large",
                          }}
                          onClick={(e) => {
                            removeStations(inDivStation);
                          }}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div>
                        <ul className="package_card_list">
                          <li>
                            <span className="pack_numb">
                              {totalSecondages &&
                                totalSecondages
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>{" "}
                            Total Seconds
                          </li>
                          <li>
                            <span className="pack_numb">
                              {rotationPerDay
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>{" "}
                            Rotations Per Day
                          </li>
                          <li>
                            <span className="pack_numb">
                              {audioDuration
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>{" "}
                            Sec Spot Duration
                          </li>
                          {discountPercent > 0 && (
                            <li>
                              <span className="pack_numb">
                                {(rotationPerDay *
                                  audioDuration *
                                  stationwisedetails[inDivStation] *
                                  totalDays *
                                  discountPercent) /
                                  (100)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </span>{" "}
                              Total Savings
                            </li>
                          )}
                        </ul>

                        <span className="package_card_total">
                          {rotationPerDay *
                            audioDuration *
                            stationwisedetails[inDivStation] *
                            totalDays -
                            (rotationPerDay *
                              audioDuration *
                              stationwisedetails[inDivStation] *
                              totalDays *
                              discountPercent) /
                              (100)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                          INR
                        </span>

                        {discountPercent > 0 && (
                          <div className="package-card-footer">{`You’ve Got ${discountPercent}% Discount`}</div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
      {showPackage && stationview === "single" && (
        <div className="package_card_wrapper">
          <div
            className="package_card_inner"
            data-aos="fade-up"
            data-aos-delay="900"
          >
            <div className="package_card_head">3 DAYS</div>
            <div>
              {" "}
              <ul className="package_card_list">
                <li>
                  <span className="pack_numb">
                    {fctPerday3
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>{" "}
                  Seconds Per Day{" "}
                </li>
                <li>
                  <span className="pack_numb">
                    {totalFct3.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>{" "}
                  Total Secondages
                </li>
                <li>
                  {" "}
                  <span className="pack_numb">
                    {totalCost3
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>
                  Total Cost
                </li>
                <li>
                  <span className="pack_numb">
                    {discount3.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                    %
                  </span>{" "}
                  Additional Benefit
                </li>
                <li>
                  <span className="pack_numb">
                    {discountedCost3
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>
                  Discounted Cost
                </li>
              </ul>
              <span className="package_card_total">
                {total3.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} INR
              </span>
              <div className="choose_plan">
                <button
                  onClick={choosePackage.bind(
                    this,
                    fctPerday3,
                    totalFct3,
                    totalCost3,
                    discount3,
                    discountedCost3,
                    3
                  )}
                >
                  CHOOSE PLAN
                </button>
              </div>
              <div className="package-card-footer">{`You’ve Got ${discount3}% Discount`}</div>
            </div>
          </div>

          <div
            className="package_card_inner"
            data-aos="fade-up"
            data-aos-delay="700"
          >
            <div className="package_card_head">5 DAYS</div>
            <div>
              {" "}
              <ul className="package_card_list">
                <li>
                  <span className="pack_numb">
                    {fctPerday5
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>{" "}
                  Seconds Per Day
                </li>
                <li>
                  <span className="pack_numb">
                    {totalFct5.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>
                  Total Secondages
                </li>
                <li>
                  <span className="pack_numb">
                    {totalCost5
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>
                  Total Cost
                </li>
                <li>
                  <span className="pack_numb">
                    {discount5.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                    %
                  </span>{" "}
                  Additional Benefit
                </li>
                <li>
                  <span className="pack_numb">
                    {discountedCost5
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>{" "}
                  Discounted Cost
                </li>
              </ul>
              <span className="package_card_total">
                {total5.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} INR
              </span>
              <div className="choose_plan">
                <button
                  onClick={choosePackage.bind(
                    this,
                    fctPerday5,
                    totalFct5,
                    totalCost5,
                    discount5,
                    discountedCost5,
                    5
                  )}
                >
                  CHOOSE PLAN
                </button>
              </div>
              <div className="package-card-footer">{`You’ve Got ${discount5}% Discount`}</div>
            </div>
          </div>
          <div
            className="package_card_inner"
            data-aos="fade-up"
            data-aos-delay="1100"
          >
            <div className="package_card_head">7 DAYS</div>
            <div>
              {" "}
              <ul className="package_card_list">
                <li>
                  <span className="pack_numb">
                    {fctPerday7
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>{" "}
                  Seconds Per Day
                </li>
                <li>
                  <span className="pack_numb">
                    {totalFct7.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>
                  Total Secondages
                </li>
                <li>
                  {" "}
                  <span className="pack_numb">
                    {totalCost7
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>{" "}
                  Total Cost
                </li>
                <li>
                  <span className="pack_numb">
                    {discount7.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                    %
                  </span>{" "}
                  Additional Benefit
                </li>
                <li>
                  <span className="pack_numb">
                    {discountedCost7
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>
                  Discounted Cost
                </li>
              </ul>
              <span className="package_card_total">
                {total7.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} INR
              </span>
              <div className="choose_plan">
                <button
                  onClick={choosePackage.bind(
                    this,
                    fctPerday7,
                    totalFct7,
                    totalCost7,
                    discount7,
                    discountedCost7,
                    7
                  )}
                >
                  CHOOSE PLAN
                </button>
              </div>
              <div className="package-card-footer">{`You’ve Got ${discount7}% Discount`}</div>
            </div>
          </div>
          {/* <div className="scroll_more">
              <span className="scroll_inner">Scroll for more</span>
            </div>   */}
        </div>
      )}
      {!showPackage && showPackage != undefined && <NoPackage />}
      <div className="scroll_more">
        <span className="scroll_txt">{props.scrollText}</span>
        <div
          className="scroll_option"
          onClick={() => props.goToScrollSection(props.currentId)}
        >
          <img
            src={
              props.scrollText == "Scroll for more"
                ? "../../../assets/images/triangle.png"
                : "../../../assets/images/triangle-up.png"
            }
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ stateList: state.user.get("stateList") });

export default connect(mapStateToProps, {
  getCityState,
})(PackageContainer);



// WEBPACK FOOTER //
// ./web/components/package/package.js